<template>
  <div class="search_box">
    <p class="add">
      <img src="/static/img/dingwei@1x.png">
      <el-popover
        v-if="city_name"
        placement="bottom"
        width="500"
        trigger="hover"
        content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。"
        v-model="visible"
        @show="showCityList"
      >
        <span slot="reference" class="city-name text-overflow pointer">{{city_name||'北京'}}</span>
        <div class="r" v-if="citylist.length>0">
          <span
            v-for="(items, index) in citylist"
            :key="index"
            :class="{'cur':city_name==items.name}"
            @click="chooseCity(items)"
            class="pointer"
          >{{items.name}}</span>
        </div>
      </el-popover>
      <span v-else class="city-name-span text-overflow pointer">北京</span>
    </p>
    <p class="search flex-1">
      <el-input
        clearable
        v-model="keywords"
        type="text"
        @change="kwChange"
        @keyup.enter.native="searchAction"
        placeholder="搜索器材名称、品牌、型号等"
      />
    </p>
    <p class="btns">
      <img src="/static/img/search_btn.png" @click="searchAction">
    </p>
  </div>
</template>
<script>
import { cityList } from "../api/index";
export default {
  name: "productSearch",
  props: {
    citylist: {
      type: Array,
      default: []
    },
    city_name: {
      type: String,
      default: "北京"
    },
    kw: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      visible: false,
      keywords: ""
    };
  },
  watch: {
    keywords(newV, oldV) {
      this.$emit("keywordsChange", newV);
    }
  },
  methods: {
    showCityList() {
      this.visible = true;
      if (this.citylist.length == 0) {
        this.$parent.getCityData();
      }
    },
    chooseCity(item) {
      this.$cookies.set("city_id", item.id);
      this.$cookies.set("city_name", item.name);
      this.$cookies.set("city_is_changed", true);
      this.$parent.city_name = item.name;
      this.$parent.city_id = item.id;
      this.$parent.$parent.$refs["header"].initData();
      this.$parent.initData();
      if (this.$route.path == "/GoodsList") {
        this.$parent.query.city_id = item.id;
        this.$parent.query.category_id = 0;
        this.$parent.activeClass = 0;
        this.searchAction();
      }
      this.visible = false;
    },
    searchAction() {
      this.$emit("transferKw", this.keywords);
    }
  },
  created() {
    this.keywords = this.kw;
  }
};
</script>

<style scoped>
.search_box {
  display: flex;
}
.search_box .add {
  width: 64px;
  display: flex;
  align-items: center;
  background: #fff;
  border-radius: 5px;
}
.search_box .add img {
  width: 10px;
  height: 13px;
  margin-left: 7px;
  margin-right: 6px;
  margin-top: -1px;
}
.search_box .search {
  /* width: 370px; */
  margin-left: 5px;
  margin-right: 5px;
  border-radius: 5px;
  overflow: hidden;
  background: #fff;
}
.search_box .search input {
  width: 100%;
  height: 100%;
  outline: 0;
}
.search_box .btns img {
  width: 40px;
  height: 40px;
  cursor: pointer;
}
.search > input {
  padding-left: 5px;
}
.r span.cur {
  color: red;
}
.city-name {
  font-size: 15px;
  display: inline-block;
  width: 40px;
  margin-top: 5px;
}
.city-name-span {
  font-size: 15px;
  display: inline-block;
  width: 40px;
}
.r {
  height: 22px;
  line-height: 22px;
}
.r span {
  margin-left: 11px;
}
</style>



// WEBPACK FOOTER //
// src/components/productSearch.vue